export default __webpack_public_path__ + "static/media/item.40ed5c79.png";